var map = {
  "./snowflake.md": [
    "33148",
    [
      773
    ]
  ],
  "./mysql.md": [
    "66714",
    [
      127
    ]
  ],
  "./sql-server.md": [
    "30994",
    [
      655
    ]
  ],
  "./postgresql.md": [
    "42400",
    [
      961
    ]
  ],
  "./databricks.md": [
    "44328",
    [
      129
    ]
  ],
  "./aws-rds.md": [
    "4947",
    [
      216
    ]
  ],
  "./bigquery.md": [
    "4892",
    [
      573
    ]
  ],
  "./presto.md": [
    "75933",
    [
      502
    ]
  ],
  "./sqlite.md": [
    "49862",
    [
      131
    ]
  ],
  "./starburst.md": [
    "24482",
    [
      215
    ]
  ],
  "./redshift.md": [
    "97519",
    [
      276
    ]
  ],
  "./druid.md": [
    "78872",
    [
      337
    ]
  ],
  "./sparksql.md": [
    "30965",
    [
      214
    ]
  ],
  "./mariadb.md": [
    "7360",
    [
      201
    ]
  ],
  "./mongodb.md": [
    "5774",
    [
      243
    ]
  ],
  "./oracle.md": [
    "44892",
    [
      861
    ]
  ],
  "./vertica.md": [
    "94482",
    [
      351
    ]
  ],
  "./clickhouse.md": [
    "44562",
    [
      95
    ]
  ],
  "./athena.md": [
    "60705",
    [
      778
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__.t(id, 1 | 16); });
}

__rspack_async_context.keys = function() { return Object.keys(map); };
__rspack_async_context.id = 81718;
module.exports = __rspack_async_context;
